import React, {Component} from 'react'
import ReactDOM from 'react-dom';
import Axios from 'axios'
import ComplainMessages from '../../components/ComplainMessages/ComplainMessages'
import ComplainHeader from '../../components/ComplainHeader/ComplainHeader'
import FormMessage from '../../components/FormMessage/FormMessage'
import Login from '../../components/Login/Login'
import { IoIosLock, IoIosTimer } from "react-icons/io";
import './ComplainsByClient.css'


class ComplainsByClient extends Component {
    constructor(){
        super()
        this.state = {
            authenticated: localStorage.getItem('token'),
            config: {
                headers: {'Authorization': 'Bearer ' + localStorage.getItem('token')}
            },
            name: window.location.hash.replace("#", ""),
            complains: [],
            idComplain: ""
        }
    }

    componentWillMount(){
        Axios.get('/api/complains/'+this.state.name, this.state.config).then(res => {
            console.log("Cliente")
            console.log(res.data)
            this.setState({complains: res.data})
        }).catch(error => {
            if(error.response.status === 401 && !this.state.authenticated){
                localStorage.clear()
                this.setState({authenticated: ""})
            }
        })
    }

    updateId = (id) => {
        console.log("update state "+ id)
        this.setState({idComplain: id})
        Axios.get('/api/complain/'+id, this.state.config).then(resComplain => {
            Axios.get('/api/messages/'+id, this.state.config).then(resMessages => {
                console.log(resMessages)
                let content = 
                <div id="complain" className="complain">
                    <div className="detail">
                        <ComplainHeader complain={resComplain.data}/>
                        <ComplainMessages messages={resMessages.data}/>
                    </div>
                    <FormMessage id={id} status={resComplain.data.status} update={this.updateId} folio={resComplain.data.folio}/>
                </div>
                ReactDOM.render(content, document.getElementById('complain'))
            }).catch(err =>{
                //agregar modal error
                console.log(err)
            })
        }).catch(err =>{
            //agregar modal error
            console.log(err)
        })
    }

    render() {
        const putComplainOpened = (complain) => {
            return <div id={complain._id}>
                <button type="submit" className="complainLink" onClick={() => { this.updateId(complain._id) }}>
                    <IoIosTimer size={26} /> {complain.folio} - {complain.stageId.name} {complain.project} {complain.location}
                </button>
            </div>
        }

        const putComplainClosed = (complain) => {
            return <div id={complain._id}>
                <button type="submit" className="complainLink" onClick={() => { this.updateId(complain._id) }}>
                    <IoIosLock size={26} /> {complain.folio} - {complain.stageId.name} {complain.project} {complain.location}
                </button>
            </div>
        }
        
        const filterClosed = (complain) => {
            return complain.status ==="Cerrado"
        }

        const filterOpened = (complain) => {
            return complain.status !== "Cerrado"
        }
        
        let content = !this.state.authenticated?
            <Login/> :
            <div className="row rowComplain">
                <div className="col-sm-2 col-md-3 col-lg-3 list">
                    <div className="closed">
                        <h3 className="complainType">Abiertas</h3>
                        {this.state.complains.filter(filterOpened).map(putComplainOpened)}
                    </div>
                    <div className="opened">
                        <h3 className="complainType">Cerradas</h3>
                        {this.state.complains.filter(filterClosed).map(putComplainClosed)}
                    </div>
                </div>
                <div className="col-sm-10 col-md-9 col-lg-9 colComplain" id="complain"></div>
            </div>
        return content
    }
}

export default ComplainsByClient


// WEBPACK FOOTER //
// ./src/views/ComplainsByClient/ComplainsByClient.js